"use strict";
const React = require('react');
const react_router_1 = require('react-router');
const IconButton_1 = require('material-ui/IconButton');
const arrow_back_1 = require('material-ui/svg-icons/navigation/arrow-back');
const handleBack = (e) => {
    e.preventDefault();
    react_router_1.browserHistory.goBack();
};
const NavigationBackIcon = (props) => React.createElement(IconButton_1.default, {onTouchTap: props.onTouchTap || handleBack}, 
    React.createElement(arrow_back_1.default, {color: "#FFF"})
);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavigationBackIcon;



/** WEBPACK FOOTER **
 ** ./src/components/NavigationBackIcon.tsx
 **/